<template>
  <div id="app">
    <!-- <router-view v-if="show" /> -->
    <!-- <keep-alive :include="['HomeView']">
    </keep-alive> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { utilsIsAlipayOrWechat, utilsHideWXCopyUrl } from "@/utils/utils.js"
import Global from './Global.js'
export default {
  name: 'app',
  data() {
    return {
      show: false,
    }
  },
  watch: {
    $route() {
      setTimeout(() => {
        let h5Environment = utilsIsAlipayOrWechat();
        if (h5Environment == 'wechat') {
          utilsHideWXCopyUrl();
        }
      }, 300)
    }
  },
  mounted() {
    sessionStorage.removeItem(Global.GlobalLocalCacheUrlList)
    let deviceWidth = document.documentElement.clientWidth || window.innerWidth;
    // console.log('deviceWidth', deviceWidth)
    if (deviceWidth > 500) {
      let appDom = document.getElementById('app');
      appDom.style.width = '500px';
      appDom.style.margin = '0 auto';
    }
    this.show = true;
    // this.hideWXCopyUrl();
  },
  methods: {
    hideWXCopyUrl() {
      function onBridgeReady() {
        window.WeixinJSBridge.call('hideOptionMenu');
      }
      if (typeof window.WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
        }
        else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
          document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
        }
      }
      else {
        onBridgeReady();
      }
    }
  }
}
</script>
